import Footer from "./views/footer";
import Header from "./views/header";
import "./App.less";
import styles from "./App.module.less";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import {
  Tabs,
  TabHeader,
  TabDropdownItem,
  ButtonFieldFloating,
  Iconsvg,
  SrOnly,
} from "@wk/components-react16";
import { useEffect, useState, useRef } from "react";
import BreadcrumbCom from "@/components/breadCrumb";
import config from "@/config/env";
import logo from "@/assets/img/logo-screen.png";
import { UserProvider, useUser } from "./utils/UserContext";
const pathList = [
  "/player",
  "/player/detail",
  "/player/personalCases",
  "/player/personalCases/add",
  "/player/personalCases/edit",
];

const judgePathList = [
  "/judgesHomepage",
  "/judgesHomepage/detail",
  "/externalRating",
  // "/externalRating/result"
];

const pcPathList = [
  "/login",
  "/register",
  "/player",
  "/player/detail",
  "/player/personalCases",
  "/privacyPolicy",
  "/player/personalCases/add",
  "/player/personalCases/edit",
  "/activation",
  "/question",
  "/judgesLogin",
  "/judgesHomepage",
  "/judgesHomepage/detail",
  "/externalRating",
  "/externalRating/result",
];

const Navigation = () => {
  const { user, judge } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const tagsList = [
    {
      name: "大赛首页",
      path: "/",
      breadName: "首页",
    },
    // {
    //   name: "大赛评委",
    //   path: "/judge",
    //   breadName: "大赛评委",
    //   parentPath: "/",
    // },
    {
      name: "往届U选",
      path: "/history",
      breadName: "往届U选",
      parentPath: "/",
    },
    {
      name: "案例模板",
      path: "/template",
      breadName: "案例模板",
      parentPath: "/",
    },
    // {
    //   name: "第八届获奖名单",
    //   path: "/awardResult?year=2025",
    //   breadName: "第八届获奖名单",
    //   parentPath: "/",
    // },
    // {
    //   name: "评委详情",
    //   path: "/judge/detail",
    //   breadName: "评委详情",
    //   parentPath: "/judge",
    //   isTagHide: true,
    // },
    {
      name: "作品详情",
      path: "/history/detail",
      breadName: "作品详情",
      parentPath: "/history",
      isTagHide: true,
    },
    {
      name: "登录/注册",
      path: "/login",
      breadName: "登录/注册",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "登录/注册",
      path: "/register",
      breadName: "登录/注册",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "个人中心",
      path: "/player",
      breadName: "选手个人主页",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "个人信息",
      path: "/player/detail",
      breadName: "个人信息",
      parentPath: "/player",
      isTagHide: true,
    },
    {
      name: "个人案例",
      path: "/player/personalCases",
      breadName: "个人案例",
      parentPath: "/player",
      isTagHide: true,
    },
    {
      name: "隐私条款",
      path: "/privacyPolicy",
      breadName: "用户隐私和服务条款",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "投稿案例",
      path: "/player/personalCases/add",
      breadName: "投稿案例",
      parentPath: "/player",
      isTagHide: true,
    },
    {
      name: "编辑案例",
      path: "/player/personalCases/edit",
      breadName: "编辑案例",
      parentPath: "/player",
      isTagHide: true,
    },
    {
      name: "激活",
      path: "/activation",
      breadName: "激活",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "常见问题",
      path: "/question",
      breadName: "常见问题",
      parentPath: "/player",
      isTagHide: true,
    },

    {
      name: "评委登录",
      path: "/judgesLogin",
      breadName: "评委登录",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "评委个人主页",
      path: "/judgesHomepage",
      breadName: "评委个人主页",
      parentPath: "/",
      isTagHide: true,
    },
    {
      name: "个人信息",
      path: "/judgesHomepage/detail",
      breadName: "个人信息",
      parentPath: "/judgesHomepage",
      isTagHide: true,
    },
    {
      name: "内部评分",
      path: "/externalRating",
      breadName: "内部评分",
      parentPath: "/judgesHomepage",
      isTagHide: true,
    },
    {
      name: "内部评分结果",
      path: "/externalRating/result",
      breadName: "内部评分结果",
      parentPath: "/judgesHomepage",
      isTagHide: true,
    },
    {
      name: "大赛结果",
      path: "/awardResult",
      breadName: "大赛结果",
      parentPath: "/",
      isTagHide: true,
    },
  ];

  const [selectedTab, setSelectedTab] = useState(0);
  const [breadcrumbList, setBreadcrumbList] = useState([]);

  const buttonRef = useRef(null);

  const logUserRequest = (event) => {
    setSelectedTab(event);
    const home = tagsList[0];
    setBreadcrumbList(
      event === 0 ? [home] : [home, tagsList[event]].filter((item) => item)
    );
    // 路由跳转
    navigate(tagsList[event].path);
  };

  // 获取当前路由以及父路由并返回数组
  const getBreadcrumbList = (currentPath, oldList = []) => {
    // 尝试带参数和不带参数的路径匹配
    let index = tagsList.findIndex((item) => item.path === currentPath);
    if (index === -1) {
      // 提取 pathname 部分进行降级匹配
      const pathnameOnly = currentPath.split("?")[0];
      index = tagsList.findIndex((item) => item.path === pathnameOnly);
    }
    
    if (index === -1) {
      return oldList;
    }
    const item = tagsList[index];
    if (!item.parentPath) {
      return [item, ...oldList];
    }
    return getBreadcrumbList(item.parentPath, [item, ...oldList]);
  };

  // 判断是否是移动端
  const option = () => {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 获取当前路由
      const pathName = location.pathname;
      if (pcPathList.includes(pathName)) {
        return;
      }
      // 获取当前路由参数
      const search = location.search;
      window.location.href = `${config.mobileSite}${pathName}${search}`;
    }
  };

  useEffect(() => {
    const pathName = location.pathname;
    if (
      pathList.includes(pathName) &&
      (!user || !user?.phone || user?.status !== "1")
    ) {
      navigate("/login");
    }
  }, [user, location]);

  useEffect(() => {
    const pathName = location.pathname;
    if (judgePathList.includes(pathName) && (!judge || !judge?.id)) {
      navigate("/judgesLogin");
    }
  }, [judge, location]);

  // 监听路由变化
  useEffect(() => {
    option();
    // console.log("当前路由位置:", location);
    const pathName = location.pathname;
    const search = location.search;
    const fullPath = pathName + search;
    // 首先尝试精确匹配带参数的路径
    let index = tagsList.findIndex((item) => item.path === fullPath);
    // 如果没找到，再回退到只匹配 pathname
    if (index === -1) {
      index = tagsList.findIndex((item) => item.path === pathName);
    }
    
    // 获取面包屑
    const breadcrumbArray = getBreadcrumbList(fullPath);
    setSelectedTab(index);
    setBreadcrumbList(breadcrumbArray);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  // 当滚动条滚动到一定位置时，显示返回顶部按钮
  useEffect(() => {
    if (!buttonRef.current) return;
    const handleScroll = () => {
      if (!buttonRef.current) return;
      if (window.scrollY > 1200) {
        buttonRef.current.style.display = "block";
      } else {
        buttonRef.current.style.display = "none";
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className={styles["App"]}>
      <Header />

      <div className={styles["tagsContainer"]}>
        <img data-v-16d0b352="" src={logo} alt="logo" />

        <div className="tags-box">
          <Tabs
            mode="default"
            selectedTab={selectedTab}
            onUserRequest={(event) => logUserRequest(event)}
          >
            {tagsList
              .filter((item) => !item.isTagHide)
              .map((item, index) => {
                return (
                  <div key={index}>
                    <TabHeader slot="tabHeader">{item.name}</TabHeader>
                    <TabDropdownItem slot="tabDropdownItem">
                      {item.name}
                    </TabDropdownItem>
                  </div>
                );
              })}
          </Tabs>
        </div>

        <div className="line-box" />
        <BreadcrumbCom items={breadcrumbList} />
      </div>

      <div className={styles["content"]}>
        <Outlet />
      </div>

      <Footer />

      <div className={styles["backToTop"]} ref={buttonRef}>
        <ButtonFieldFloating>
          <button
            type="button"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <Iconsvg name="arrow-up"></Iconsvg>
            <SrOnly>Go up</SrOnly>
          </button>
        </ButtonFieldFloating>
      </div>
    </div>
  );
};
const Index = () => {
  return (
    <UserProvider>
      <Navigation />
    </UserProvider>
  );
};

export default Index;
